export default __webpack_public_path__ + "static/media/deathlyblizzard.5c3da472.png";